import {Base} from "@/api/Base"

export class OvertimeApplicationSend extends Base {
    path = "overtimeApplication/send"
}